import React, { useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { useSeo } from "../hooks/useSeo";

/**
 * Au changement de page : défile vers l'ancre demandée, ou revient en haut
 * et place le focus sur le contenu pour les lecteurs d'écran. Rien au
 * premier affichage : le navigateur gère déjà l'ancre de l'adresse.
 */
const useDefilementNavigation = (mainRef) => {
  const { pathname, hash } = useLocation();
  const premier = useRef(true);

  useEffect(() => {
    if (premier.current) {
      premier.current = false;
      return;
    }
    if (hash) {
      document.getElementById(hash.slice(1))?.scrollIntoView();
      return;
    }
    window.scrollTo(0, 0);
    mainRef.current?.focus({ preventScroll: true });
  }, [pathname, hash, mainRef]);
};

export const Layout = () => {
  const mainRef = useRef(null);
  useSeo();
  useDefilementNavigation(mainRef);

  return (
    <>
      <a
        href="#contenu"
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[1100] focus:rounded-[8px] focus:bg-white focus:px-4 focus:py-3 focus:text-vt-controle focus:font-bold focus:text-brand"
      >
        Aller au contenu
      </a>
      <Header />
      <main id="contenu" ref={mainRef} tabIndex={-1} className="outline-none">
        <Outlet />
      </main>
      <Footer />
    </>
  );
};
